// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Scrollable from "../../../../../../library/components/Scrollable.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as DateTime$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as SendSmsDataMachine from "../../../app/repo/SendSmsDataMachine.bs.js";
import * as SendSMSAssetsManager from "../../assets/SendSMSAssetsManager.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as PreviouslySentMessagesErrorView from "./PreviouslySentMessagesErrorView.bs.js";

SendSMSAssetsManager.importCss(undefined);

var send_icon = SendSMSAssetsManager.getImage("send-icon.svg");

function PreviouslySentMessagesListView(Props) {
  var openSnackbar = Props.openSnackbar;
  var phoneNumber = Props.phoneNumber;
  var previouslySentMessagesDetails = Props.previouslySentMessagesDetails;
  var dispatchPreviouslySentMessagesDetailsLive = Props.dispatchPreviouslySentMessagesDetailsLive;
  var on_resend_click = Props.on_resend_click;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var getColumnSchema = function (onResendClick) {
    return {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Phone Number"
              },
              accessor: (function ($$document) {
                  return {
                          TAG: /* Text */0,
                          _0: $$document.phone_number
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Message"
                },
                accessor: (function ($$document) {
                    return {
                            TAG: /* Text */0,
                            _0: $$document.message
                          };
                  })
              },
              tl: {
                hd: {
                  column: {
                    TAG: /* Text */0,
                    _0: "Response/ Status"
                  },
                  accessor: (function ($$document) {
                      var status = $$document.status;
                      if (status !== undefined) {
                        return {
                                TAG: /* Text */0,
                                _0: status
                              };
                      } else {
                        return {
                                TAG: /* Text */0,
                                _0: "N/A"
                              };
                      }
                    })
                },
                tl: {
                  hd: {
                    column: {
                      TAG: /* Text */0,
                      _0: "Order ID"
                    },
                    accessor: (function ($$document) {
                        var order_id = $$document.order_id;
                        if (order_id !== undefined) {
                          return {
                                  TAG: /* Text */0,
                                  _0: order_id
                                };
                        } else {
                          return {
                                  TAG: /* Text */0,
                                  _0: "N/A"
                                };
                        }
                      })
                  },
                  tl: {
                    hd: {
                      column: {
                        TAG: /* Text */0,
                        _0: "Sent At"
                      },
                      accessor: (function ($$document) {
                          return {
                                  TAG: /* Text */0,
                                  _0: DateTime$Catalyst.toString("h:mm A Do MMM yyyy ", DateTime$Catalyst.fromString("YYYY-MM-DD hh:mm:ss a", $$document.created_at))
                                };
                        })
                    },
                    tl: {
                      hd: {
                        column: {
                          TAG: /* Text */0,
                          _0: "Status Details"
                        },
                        accessor: (function ($$document) {
                            return {
                                    TAG: /* Custom */5,
                                    _0: (function (param) {
                                        return React.createElement("div", {
                                                    className: "status-details-img-container cursor-pointer",
                                                    onClick: (function (_event) {
                                                        return Curry._1(onResendClick, $$document);
                                                      })
                                                  }, React.createElement("div", undefined, $$document.status_details), React.createElement("img", {
                                                        src: send_icon
                                                      }));
                                      })
                                  };
                          })
                      },
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          };
  };
  var onResendClick = Curry.__1(on_resend_click);
  var tmp;
  if (typeof previouslySentMessagesDetails === "number") {
    tmp = React.createElement(CircularLoader$Catalyst.make, {});
  } else {
    switch (previouslySentMessagesDetails.TAG | 0) {
      case /* Loading */0 :
          tmp = React.createElement(CircularLoader$Catalyst.make, {});
          break;
      case /* Live */1 :
          tmp = React.createElement(Scrollable.make, {
                height: "100vh",
                onScrollEndCallback: (function (param) {
                    var tmp;
                    if (typeof previouslySentMessagesDetails === "number" || previouslySentMessagesDetails.TAG !== /* Live */1) {
                      tmp = "";
                    } else {
                      var data = previouslySentMessagesDetails._0;
                      tmp = List.nth(data, List.length(data) - 1 | 0).created_at;
                    }
                    return SendSmsDataMachine.fetchSmsList({
                                phone_number: phoneNumber,
                                limit: 20,
                                pagination_token: tmp
                              }, country, (function (data) {
                                  var tmp;
                                  tmp = typeof previouslySentMessagesDetails === "number" || previouslySentMessagesDetails.TAG !== /* Live */1 ? data : List.append(previouslySentMessagesDetails._0, data);
                                  return Curry._1(dispatchPreviouslySentMessagesDetailsLive, tmp);
                                }), (function (error) {
                                  return Curry._1(openSnackbar, {
                                              TAG: /* Error */1,
                                              _0: "Submission Failed! Error : API link broken. Please Try submitting again"
                                            });
                                }));
                  }),
                children: React.createElement(TableComponent$Catalyst.make, {
                      columns: getColumnSchema(onResendClick),
                      rowData: previouslySentMessagesDetails._0,
                      className: "table-container",
                      is_sticky_header: true
                    })
              });
          break;
      case /* Error */2 :
          tmp = React.createElement(PreviouslySentMessagesErrorView.make, {});
          break;
      
    }
  }
  return React.createElement("div", {
              className: "c-previously-sent-messages-view"
            }, React.createElement("div", {
                  className: "heading-section"
                }, "Previously sent messages"), tmp);
}

var make = PreviouslySentMessagesListView;

export {
  send_icon ,
  make ,
  
}
/*  Not a pure module */
